import DataStore from './../stores/DataStore'
/**
 * @class
 * Klasse, die, sofern eine Bedingung erfüllt wird, den Effekt einer Attributabhängigkeit triggern soll.
 */
class EffectHandler {
  /**
   *
   * @constructor
   * @param {object} effect
   * @param {string[]} [effect.display=[]]
   * @param {string[]} [effect.hidden=[]]
   * @param {string[]} [effect.required=[]]
   * @param {string[]} [effect.forbidden=[]]
   * @param {string[]} [effect.optional=[]]
   * @param {string[]} [effect.editable=[]]
   * @param {string[]} [effect.readOnly=[]]
   * @param {Function} [effect.customFunction]
   * @param {string[]} [effect.customAttributes]
   */
  constructor(params) {
    const {
      display = [],
      hidden = [],
      required = [],
      forbidden = [],
      optional = [],
      editable = [],
      readOnly = [],
      customFunction = undefined,
      customAttributes = [],
      attributeOptions= undefined
    } = params;
    this.display = display;
    this.attributeOptions = attributeOptions; 
    this.hidden = hidden;
    this.required = required;
    this.forbidden = forbidden;
    this.optional = optional;
    this.editable = editable;
    this.readOnly = readOnly;
    this.customFunction = customFunction;
    this.customAttributes = customAttributes;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.DataStore = DataStore;
  }

  /**
   * @function EffectHandler.getString
   * @return {String} Beschreibung des Effektes
   */
  getString() {
    let effectString = '';
    if (this.display.length > 0)
      effectString = `${effectString}( display: [${this.display.join()}])`;
    if (this.hidden.length > 0)
      effectString = `${effectString}( hidden: [${this.hidden.join()}])`;
    if (this.required.length > 0)
      effectString = `${effectString}( required: [${this.required.join()}])`;
    if (this.forbidden.length > 0)
      effectString = `${effectString}( forbidden: [${this.forbidden.join()}])`;
    if (this.optional.length > 0)
      effectString = `${effectString}( optional: [${this.optional.join()}])`;
    if (this.editable.length > 0)
      effectString = `${effectString}( editable: [${this.editable.join()}])`;
    if (this.readOnly.length > 0)
      effectString = `${effectString}( readOnly: [${this.readOnly.join()}])`;
    if (this.customAttributes.length > 0)
      effectString = `${effectString}( customFunction: [${this.customAttributes.join()}])`;
    return effectString;
  }

  /**
   * @function EffectHandler.triggerEffect Löst die Effekte aus.
   */
  triggerEffect() {
    if(this.attributeOptions){
      const {id, options}= this.attributeOptions; 
      this.DataStore.attributeValues[id].setAttributeOptions(options); 
    }
    this.display.forEach(d => {
      this.DataStore.attributeValues[d].setVisible(true);
    });
    this.hidden.forEach(d => {
      this.DataStore.attributeValues[d].setVisible(false);
    });
    this.required.forEach(d => {
      this.DataStore.attributeValues[d].setRequired(true);
    });
    this.forbidden.forEach(d => {
      this.DataStore.attributeValues[d].setForbidden(true);
    });
    this.optional.forEach(d => {
      this.DataStore.attributeValues[d].setRequired(false);
    });
    this.editable.forEach(d => {
      this.DataStore.attributeValues[d].setReadOnly(false);
    });
    this.readOnly.forEach(d => {
      this.DataStore.attributeValues[d].setReadOnly(true);
    });
    this.customAttributes.forEach(d => {
      this.customFunction(
        this.DataStore.attributeValues[d],
        true,
      );
    });
  }

  /**
   * @function EffectHandler.triggerEffect Setzt Effekte zurück
   */
  resetEffects() {
    // if(this.attributeOptions){
    //   const {id}= this.attributeOptions; 
    //   this.DataStore.attributeValues[id].setAttributeOptions(); 
    // }
    this.display.forEach(d => {
      this.DataStore.attributeValues[d].resetVisible(true);
    });
    this.hidden.forEach(d => {
      this.DataStore.attributeValues[d].resetVisible(false);
    });
    this.required.forEach(d => {
      this.DataStore.attributeValues[d].resetRequired(true);
    });
    this.forbidden.forEach(d => {
      this.DataStore.attributeValues[d].resetForbidden(true);
    });
    this.optional.forEach(d => {
      this.DataStore.attributeValues[d].resetRequired(false);
    });
    this.editable.forEach(d => {
      this.DataStore.attributeValues[d].resetReadOnly(false);
    });
    this.readOnly.forEach(d => {
      this.DataStore.attributeValues[d].resetReadOnly(true);
    });
    this.customAttributes.forEach(d => {
      this.customFunction(
        this.DataStore.attributeValues[d],
        false,
      );
    });
  }
}

export default EffectHandler;
